export type AnalyticsCardPlacement = {
	position: 'bottom-start' | 'left-start';
	offset: [number, number];
};

export const DEFAULT_ANALYTICS_CARD_PLACEMENT: AnalyticsCardPlacement = {
	position: 'bottom-start',
	offset: [0, 8],
};

export const getDialogBesideCardPlacement = (
	dialogRect?: Pick<DOMRect, 'left' | 'width' | 'height'> | null,
	triggerRect?: Pick<DOMRect, 'left'> | null,
): AnalyticsCardPlacement => {
	if (!dialogRect || !triggerRect || (dialogRect.width === 0 && dialogRect.height === 0)) {
		return DEFAULT_ANALYTICS_CARD_PLACEMENT;
	}
	return {
		position: 'left-start',
		offset: [0, triggerRect.left - dialogRect.left + 8],
	};
};
